import { create } from 'zustand';

import { verifyOkta, type VerifyOktaPayload } from '@/entities/auth';
import service from '@/services/index';

export type UserT = {
  user_id: string;
  firstName: string;
  lastName: string;
  email: string;
  hasWorkspace: boolean;
  color: number;
};

type State = {
  user: UserT | null;
};

type Actions = {
  setUser: (user: UserT | null) => void;
  updateHasWorkspaceStatus: (data: boolean) => void;
  verfiyUser: (token: string, type: string) => Promise<boolean>;
  verifyOktaUser: (payload: VerifyOktaPayload) => Promise<boolean>;
  checkUser: () => void;
  inviteWorkspace: (code: string) => Promise<any>;
  initUserStore: () => void;
};

const initialState: State = {
  user: null,
};

const useUserStore = create<State & Actions>((set) => ({
  ...initialState,
  setUser: (user) => {
    set((state) => ({
      ...state,
      user,
    }));
  },
  updateHasWorkspaceStatus: (data) => {
    set((state) => ({
      ...state,
      user: state.user && {
        ...state.user,
        hasWorkspace: data,
      },
    }));
  },
  verfiyUser: async (token, type) => {
    const data = await service.auth.authVerify(token, type);
    if (data) {
      set((state) => ({
        ...state,
        user: {
          user_id: data.user_id,
          firstName: data.first_name,
          lastName: data.last_name,
          email: data.email,
          hasWorkspace: data.has_workspace,
          color: data.color,
        },
      }));
      return true;
    } else {
      return false;
    }
  },
  verifyOktaUser: async (payload) => {
    const data = await verifyOkta(payload);
    if (data) {
      set((state) => ({
        ...state,
        user: {
          user_id: data.user_id,
          firstName: data.first_name,
          lastName: data.last_name,
          email: data.email,
          hasWorkspace: data.has_workspace,
          color: data.color,
        },
      }));
      return true;
    }

    return false;
  },
  checkUser: async () => {
    const data = await service.auth.authCheck();
    if (data) {
      set((state) => ({
        ...state,
        user: {
          user_id: data.user_id,
          firstName: data.first_name,
          lastName: data.last_name,
          email: data.email,
          hasWorkspace: !!data.workspaces?.length,
          color: data.color,
        },
      }));
    } else {
      set((state) => ({
        ...state,
        user: null,
      }));
    }
  },
  inviteWorkspace: async (code: string) => {
    const data = await service.auth.inviteWorkspace(code);
    if (data) {
      if (data.alias) {
        set((state) => ({
          ...state,
          user: state.user && {
            ...state.user,
            hasWorkspace: true,
          },
        }));
      }
      return data;
    } else {
      return false;
    }
  },

  initUserStore() {
    set(initialState);
  },
}));

export default useUserStore;
